export class PostResult {
  isError: boolean;
  errorDescription: string;
  value: object;
}
